<div class="card bg-base-100 shadow-sm border border-base-300" [class.border-warning]="urgentCount() > 0">
  <div class="card-body">
    <!-- Heading -->
    <div class="flex flex-wrap items-center gap-2 mb-1">
      <span nz-icon nzType="cloud-download" class="text-warning"></span>
      <h3 class="font-semibold text-base-content">Operations Awaiting Media</h3>

      <span class="badge badge-warning badge-sm font-semibold ms-auto" *ngIf="!isFirstLoad()">{{ total() }}</span>
      <!-- A dash, not a zero: a zero would claim there are none while we are still asking. -->
      <span class="text-base-content/40 ms-auto" *ngIf="isFirstLoad()">–</span>
    </div>

    <p class="text-xs text-base-content/60 mb-3">
      Trips that arrived but are still missing camera footage. They are not auditable until every crossing is complete.
    </p>

    <!-- Loading: first paint only -->
    <div *ngIf="isFirstLoad()" class="space-y-2 animate-pulse" aria-hidden="true">
      <div class="h-6 w-2/3 rounded bg-base-300"></div>
      <div class="h-10 w-full rounded bg-base-300"></div>
    </div>

    <ng-container *ngIf="!isFirstLoad()">
      <!-- Nothing waiting -->
      <div *ngIf="total() === 0" class="flex items-center gap-2 py-2 text-sm text-success">
        <span nz-icon nzType="check-circle"></span>
        Every arrived trip has all of its footage.
      </div>

      <ng-container *ngIf="total() > 0">
        <!-- Age breakdown: the reason this widget exists -->
        <div class="flex flex-wrap gap-2 mb-3">
          <span
            *ngFor="let bucket of ageBuckets()"
            class="badge badge-sm gap-1"
            [class.badge-ghost]="!bucket.urgent"
            [class.badge-error]="bucket.urgent"
            nz-tooltip
            [nzTooltipTitle]="bucket.count + ' trip(s) waiting ' + bucket.label"
          >
            {{ bucket.label }}
            <span class="font-semibold">{{ bucket.count }}</span>
          </span>
        </div>

        <p *ngIf="urgentCount() > 0" class="text-xs text-error mb-3 flex items-center gap-1">
          <span nz-icon nzType="warning"></span>
          {{ urgentCount() }} waiting over 6 hours — footage may never arrive on its own.
        </p>

        <!-- Oldest first -->
        <ul class="divide-y divide-base-300 -mx-2">
          <li *ngFor="let op of previewRows(); trackBy: trackById" class="px-2 py-2">
            <div class="flex items-center gap-2 mb-1">
              <span class="text-sm font-medium text-base-content truncate flex-1 min-w-0">{{ op.routeName }}</span>
              <span class="badge badge-ghost badge-sm flex-shrink-0">{{ op.percentComplete }}%</span>
            </div>
            <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-base-content/60">
              <span *ngIf="op.busName" class="flex items-center gap-1">
                <span nz-icon nzType="car"></span>{{ op.busName }}
              </span>
              <span>{{ op.completeCrossings }}/{{ op.totalCrossings }} crossings</span>
              <span>waiting {{ humanMinutes(op.ageMinutes) }}</span>
              <span
                class="flex items-center gap-1"
                [class.text-error]="diagnosis(op).tone === 'error'"
                [class.text-warning]="diagnosis(op).tone === 'warning'"
              >
                {{ diagnosis(op).label }}
              </span>
            </div>
          </li>
        </ul>

        <p *ngIf="overflowCount() > 0" class="text-xs text-base-content/50 mt-2">
          and {{ overflowCount() }} more
        </p>

        <div class="card-actions justify-end mt-3">
          <a routerLink="/audits/ready" class="btn btn-ghost btn-xs gap-1">
            View all
            <span nz-icon nzType="arrow-right"></span>
          </a>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
